import React, { useEffect, useState } from 'react';

import { useAPI } from '../../api';
import { useParams } from 'react-router-dom';
import PageSection from '../../components/PageSection';
import { TenantInfo } from 'types';
import PropEditor from 'components/PropEditor';
import RawJsonDisplay from 'components/RawJsonDisplay';
import { OrgContextLink, useOrgContext } from 'components/OrgContextProvider';

const TenantContainer = () => {
	const api = useAPI();

	const tenantWorkspaceProvider = useOrgContext();

	const { tenantID } = useParams();

	const [tenant, setTenant] = useState<TenantInfo | null>(null);

	const loadTenant = () => {
		api.get<TenantInfo>(`/api/tenants/${tenantID}`)
		.then(json => setTenant(json))
		.catch(() => setTenant(null));
	};

	useEffect(() => {
		loadTenant();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tenantID]);

	return (
		<div>
			<PageSection title={`Tenant: ${tenant?.name ?? tenantID}`} level={2} />

			<PageSection borderEnd={true}>
				<OrgContextLink to="/settings/tenants">&#x25c0; Back to Tenants</OrgContextLink>
			</PageSection>

			<PageSection title="Tenant Info">
				<PropEditor<TenantInfo | null>
					object={tenant}
					onChange={(obj) => setTenant(obj)}
					props={[
						{ label: 'Name', key: 'name' },
						{ label: 'ID', key: 'id', disabled: true },
						{ label: 'Account ID', key: 'accountID', disabled: true },
						{ label: 'Hostname', key: 'hostname', placeholder: 'e.g. tenant.app.fastvue.co' }
					]}
					tools={[
						() => (<button type="button" onClick={() => api.put(`/api/tenants/${tenantID}`, { name: tenant?.name, hostname: tenant?.hostname || null }).then(loadTenant).then(tenantWorkspaceProvider?.reload) }>Save Tenant</button>)
					]}
				/>
			</PageSection>

			<PageSection title="Workspaces" level={3}>
				<p><OrgContextLink to="/settings/workspaces">Manage workspaces &rarr;</OrgContextLink></p>
				<p><OrgContextLink to={`/settings/workspaces/new?tenantID=${tenantID}`}>Create new workspace for this tenant &rarr;</OrgContextLink></p>
			</PageSection>

			<PageSection title="Raw">
				<RawJsonDisplay data={tenant} />
			</PageSection>
		</div>
	);
};

export default TenantContainer;
